// src/pages/Projects.jsx

import Footer from '../components/Footer';

import ProjectShowcase from '../components/Project/SKIPER/PresentationPage';


const Projects = () => (
  <div>

    <ProjectShowcase/>
    <Footer/>

</div>
  );
  
  export default Projects;